module.exports = __webpack_public_path__ + "static/media/home-banner.d8b5ef03.jpg";